/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  title: {
    id: "b2b.notifikace.title",
    defaultMessage: "Notifications"
  },
  emptyMessage: {
    id: "b2b.notifikace.empty",
    defaultMessage: "U have no notifications"
  },
  readAll: {
    id: "b2b.notifikace.read-all",
    defaultMessage: "Read all"
  },
  deleteAll: {
    id: "b2b.notifikace.delete-all",
    defaultMessage: "Delete all"
  },
  successRead: {
    id: "b2b.notifikace.success-read",
    defaultMessage:
      "{length, plural, one {Notification was read} other {Notifications were read}}"
  },
  successDelete: {
    id: "b2b.notifikace.success-delete",
    defaultMessage:
      "{length, plural, one {Notification was deleted} other {Notifications were deleted}}"
  }
});

export default () => useMessages(MESSAGES);
